const logo = {
  mobile: require('./mobile.png')
};

export { logo };